import { AxiosPromise } from 'axios';

import { Disease, DiseaseListItem, GetDiseasesParams, PaginatedResponse } from 'shared/api';
import { apiInstance } from 'shared/api/typicode/base';

const BASE_URL = '/disease-pets';

/**
 * Получение списка болезней для питомцев с пагинацией и фильтрацией
 * @param params - Параметры запроса (фильтрация, сортировка, пагинация)
 * @returns Promise с ответом, содержащим массив болезней и информацию о пагинации
 */
export const getDiseasesAll = async (params?: GetDiseasesParams): AxiosPromise<PaginatedResponse<DiseaseListItem>> =>
  apiInstance.get(`${BASE_URL}/all`, {
    params,
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });

/**
 * Получение болезни по ID
 * @param id - ID болезни
 * @returns Promise с полным объектом болезни
 */
export const getDiseaseById = async (id: string): AxiosPromise<Disease> =>
  apiInstance.get(`${BASE_URL}/${id}`, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });

/**
 * Добавление новой болезни для питомцев
 */
export const postDisease = async (data: Omit<Disease, '_id'>): AxiosPromise<Disease> =>
  apiInstance.post(`${BASE_URL}`, data, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });

/**
 * Обновление болезни для питомцев
 */
export const patchDisease = async (data: Disease): AxiosPromise<Disease> => {
  const { _id, ...datas } = data;

  return apiInstance.patch(`${BASE_URL}/${_id}`, datas, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });
};
